<template>
	<Footer>
		<template #footerBar>
			<div class="grid grid-cols-3">
				<div class="flex justify-center col-start-2">
					<AtomSocialButtons
						:facebook="facebookPageUrl"
						:instagram="instagramPageUrl"
						:threads="threadsPageUrl"
					/>
				</div>
			</div>
		</template>
		<template #default>
			<div class="flex gap-12 flex-col">
				<MoleculeContactBlock
					:company-data="{
						...fitCompanyData,
						...baseCompanyData,
					}"
				/>
				<div
					class="
				flex
				flex-col
				gap-6"
				>
					<div class="cursor:hidden">
						<AtomButton
							size="sm"
							:to="phoneLink"
							:variant="ButtonVariant.Green"
							icon-left="fa-phone"
							text="Fysio Hier bellen"
							@click="trackClickToCall('OrganismFooter_bellen_mobiel')"
						/>
					</div>
					<div>
						<AtomButton
							size="sm"
							:variant="ButtonVariant.Green"
							icon-left="fa-calendar-days"
							text="Afspraak maken"
							@click="emit('openAppointmentDialog')"
						/>
					</div>
					<div class="cursor:hidden">
						<AtomButton
							:to="{
								url: baseCompanyData.mapsUrl,
								title: 'Navigeer naar Fysio Hier',
							}"
							size="sm"
							:variant="ButtonVariant.Brand"
							icon-left="fa-map-location"
							text="Navigeer naar Fysio Hier"
						/>
					</div>
				</div>
			</div>
			<div class="lg:col-start-3 col-span-2 md:columns-2 gap-x-32">
				<AtomListLink
					v-for="(item, index) in links"
					:key="`atom-link-list-${index}-${item.text}`"
					:item
					class="mb-8"
				/>
			</div>
		</template>
		<template #legal>
			<p>
				© 2023 - {{ getYear() }} <span class="mx-2.5" /> {{ baseCompanyData.legalName }}
			</p>
		</template>
	</Footer>
</template>

<script lang="ts" setup>
import Footer from '#base/app/components/organism/Footer/index.vue';
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
import type { MenuItemType } from '#base/core/types/MenuItemType';
import type { UrlType } from '#base/core/types/UrlType';
import { getYear } from '#base/helpers/dateHelpers';
import * as fitCompanyData from '#fysio/core/consts/companyData';
import * as baseCompanyData from '#base/core/consts/companyData';
import { facebookPageUrl, instagramPageUrl, threadsPageUrl } from '#fysio/core/consts/socialMediaPages';

defineProps<{
	links: MenuItemType[];
	phoneLink: UrlType;
}>();

const { trackClickToCall } = useEventTracking();

const emit = defineEmits(['openAppointmentDialog']);
</script>

<style lang="postcss" scoped>
:deep(h1),
:deep(h2),
:deep(h3),
:deep(h4),
:deep(h5),
:deep(h6) {
  @apply text-purple-100;
}
</style>
